// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"192":"31d6cfe0","806":"cce23cfb"}[chunkId] + ".chunk.css";
};